import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgTickNo({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M2.65 1.35c.2-.2.5-.2.7 0L8 5.95l4.65-4.6c.2-.2.5-.2.7 0l1.37 1.37c.2.2.2.5 0 .7L10.07 8l4.63 4.58c.2.2.2.5 0 .7l-1.36 1.37c-.2.2-.5.2-.7 0L8 10.05l-4.65 4.6a.5.5 0 01-.7 0l-1.37-1.37a.5.5 0 010-.7L5.93 8 1.29 3.42a.5.5 0 010-.7z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgTickNo.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgTickNo.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgTickNo svgRef={ref} {...props} />);
export default ForwardRef;
